import React from "react"
import { Grid, Col, Row } from "react-styled-flexboxgrid"
import styled, { ThemeProvider } from "styled-components"

import icoMoon from "~/components/IcoMoon"
import Spacer from "~/components/Spacer"
import selection from "./selection.json"

const Container = styled.div`
  max-width: ${(props) => (props.theme.media.mobile ? "300px" : "170px")};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
`

const Text = styled.div`
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.text.label};
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 0.9em;
  text-align: center;
`

const IconCircle = styled.span`
  height: 50px;
  width: 50px;
  background-color: ${(props) => props.theme.colors.text.mainFooter};
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0px 6px 16px 0px rgba(35, 41, 48, 0.15);
  text-align: center;
  line-height: 55px;
  vertical-align: baseline;
`

const HowItWorksGrid = ({
  COLUMN_CONTENT,
  GRID_THEME,
  COLUMNS,
  ICON_STYLE,
}) => {
  const Icon = icoMoon(selection)
  return (
    <ThemeProvider theme={GRID_THEME}>
      <Grid style={{ width: "100%" }}>
        <Row>
          {COLUMN_CONTENT.map((CONTENT) => {
            return (
              <Col
                key={CONTENT.name}
                {...COLUMNS.item}
                style={{
                  display: "flex",
                  flexShrink: 0,
                  justifyContent: "center",
                }}
              >
                <Container>
                  <IconCircle>
                    <Icon icon={CONTENT.iconName} style={ICON_STYLE} />
                  </IconCircle>
                  <Spacer mobile={25} desktop={25} />
                  <Text color={CONTENT.color}>
                    {CONTENT.name.toUpperCase()}
                  </Text>
                  <Spacer mobile={6} desktop={6} />
                  <Text>{CONTENT.text}</Text>
                </Container>
              </Col>
            )
          })}
        </Row>
      </Grid>
    </ThemeProvider>
  )
}

export default HowItWorksGrid
